import { useNotificationTemplateData } from "../../../model/use-notification-template-data";
import { PropertyTree } from "@/shared/template-properties/ui/property-tree";

export function PropertyTreeByNotificationTemplate({ id }: { id?: string }) {
  const { data } = useNotificationTemplateData(id);

  return (
    <PropertyTree
      properties={data?.getNotificationTemplateById.properties ?? []}
    />
  );
}
